'use strict'

import events from 'assets/themes/campings/js/module/searchForm/events'
import autocomplete from 'assets/themes/campings/js/page/homepage/form/autocomplete'
import overlay from 'assets/themes/campings/js/page/homepage/form/overlay'

export default function (): void {
  autocomplete()
  overlay()
  events()
}
